/**
 * FacetedFiltering Security Patch
 * 
 * This script patches the FacetedFiltering class to use safe URL parameter processing
 * and prevents prototype pollution through query string manipulation.
 */

(function() {
    'use strict';

    // Wait for the main startup.js to load
    document.addEventListener('DOMContentLoaded', function() {
        // Patch the FacetedFiltering class if it exists
        if (window.FacetedFiltering || (window.startup && window.startup.FacetedFiltering)) {
            const FacetedFiltering = window.FacetedFiltering || window.startup.FacetedFiltering;
            
            // Store original method
            const originalBuildFilterQuery = FacetedFiltering.prototype._buildFilterQuery;
            
            // Override with safe version
            FacetedFiltering.prototype._buildFilterQuery = function(element) {
                let searchParameters;
                
                if (element.dataset.hasOwnProperty('filterRange')) {
                    const currentSearch = window.location.search.replace('?', '');
                    const formData = new FormData(element.closest('form'));
                    const newSearch = new URLSearchParams(formData).toString();
                    
                    // Safely parse current search parameters
                    const splitCurrentSearch = currentSearch.split('&');
                    let filteredCurrentSearch = splitCurrentSearch.filter(search => {
                        // Check for dangerous parameters
                        if (search.includes('__proto__') || 
                            search.includes('proto') ||
                            search.includes('constructor') || 
                            search.includes('prototype')) {
                            return false;
                        }
                        
                        if (search.includes(this.rangeNames[0]) || search.includes(this.rangeNames[1])) {
                            return false;
                        }
                        
                        return true;
                    });
                    
                    filteredCurrentSearch = filteredCurrentSearch.join('&');
                    
                    if (filteredCurrentSearch.length > 0) {
                        searchParameters = `${filteredCurrentSearch}&${newSearch}`;
                    } else {
                        searchParameters = `${newSearch}`;
                    }
                }
                
                let urlQueryString = '';
                urlQueryString = `?${searchParameters}`;
                return urlQueryString;
            };
            
            // FacetedFiltering security patch applied
        }
    });

    // Additional protection for URLSearchParams
    if (window.URLSearchParams) {
        const originalURLSearchParams = window.URLSearchParams;
        
        window.URLSearchParams = function(init) {
            const instance = new originalURLSearchParams(init);
            
            // Override the set method to block dangerous parameters
            const originalSet = instance.set;
            instance.set = function(name, value) {
                if (typeof name === 'string' && 
                    (name.includes('__proto__') || 
                     name.includes('proto') ||
                     name.includes('constructor') || 
                     name.includes('prototype'))) {
                    return;
                }
                return originalSet.call(this, name, value);
            };
            
            return instance;
        };
        
        // Copy static methods
        Object.setPrototypeOf(window.URLSearchParams, originalURLSearchParams);
        Object.defineProperty(window.URLSearchParams, 'prototype', {
            value: originalURLSearchParams.prototype,
            writable: false
        });
    }

})();
